import { Box, Flex, Text } from '@chakra-ui/react'
import { getImage } from '@helper/getImage'
import useWindowSize from '@hooks/use-window-size'
import cn from 'classnames'
import { isEmpty } from 'lodash'
import secureLocalStorage from 'react-secure-storage'

interface HeaderProps {
  banner?: any
  heroTitle?: string
  variant?: 'default' | 'white'
}

const PageHeroSection: React.FC<HeaderProps> = ({
  banner,
  heroTitle = 'text-page-title',
  variant = 'default',
}) => {
  const { width } = useWindowSize()
  const theme: any = secureLocalStorage.getItem('theme')
  const brandColor = theme?.colors?.primary

  const { uuid } = banner?.selected ?? {}

  const selectedImage = getImage(width!, uuid)
  let gradient = 'linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%)'
  if (!isEmpty(brandColor)) {
    gradient = `linear-gradient(40deg, ${brandColor[500]} 0%, ${brandColor[100]} 100%)`
  }
  const backGroundStyle = {
    backgroundImage: `url('${selectedImage}'), ${gradient}`,
    backgroundBlendMode: 'multiply',
  }
  return (
    <div
      className={cn(
        'flex justify-center md:min-h-[250px] lg:min-h-[288px] py-20 w-full bg-cover bg-no-repeat bg-center page-header-banner',
        {
          'style-variant-white': variant === 'white',
        },
      )}
      style={{ ...backGroundStyle }}
    >
      <Flex
        gap={3}
        className="w-full flex flex-col items-center justify-center relative"
      >
        <Text
          as="h2"
          color={variant === 'white' ? 'whiteAlpha.700' : 'skin-inverted'}
          className={cn(
            'text-xl md:text-2xl lg:text-3xl 2xl:text-[40px] font-bold text-center',
            {
              'text-skin-base': variant === 'default',
              'text-skin-inverted': variant === 'white',
            },
          )}
        >
          <Text
            color="white"
            className="  block font-bold mb-3 md:mb-4 lg:mb-5 2xl:mb-7 "
          >
            {heroTitle}
          </Text>
        </Text>
        <Box color="white" mt={2}>
          {/* <Breadcrumb /> */}
        </Box>
      </Flex>
    </div>
  )
}

export default PageHeroSection
